import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CtasState = {
  hasSeenDifferentiation: boolean;
  hasSeenDownload: boolean;
  hasSeenBookmark: boolean;
  hasSeemAssignments: boolean;
  hasSeemGroups: boolean;
  hasSeenTableOfContents: boolean;
  hasSeenFollowUp: boolean;
  hasSeenGradeManager: boolean;
  hasSeenManual: boolean;
  hasSeenPresentation: boolean;
};

const initialState: CtasState = {
  hasSeenDifferentiation: false,
  hasSeenDownload: false,
  hasSeenBookmark: false,
  hasSeemAssignments: false,
  hasSeemGroups: false,
  hasSeenTableOfContents: false,
  hasSeenFollowUp: false,
  hasSeenGradeManager: false,
  hasSeenManual: false,
  hasSeenPresentation: false,
};

export const ctasSlice = createSlice({
  name: 'ctasSlice',
  initialState,
  reducers: {
    setHasSeenDifferentiation: (state, action: PayloadAction<boolean>) => {
      state.hasSeenDifferentiation = action.payload;
    },
    setHasSeemAssignments: (state, action: PayloadAction<boolean>) => {
      state.hasSeemAssignments = action.payload;
    },
    setHasSeenGroup: (state, action: PayloadAction<boolean>) => {
      state.hasSeemGroups = action.payload;
    },
    setHasSeenDownload: (state, action: PayloadAction<boolean>) => {
      state.hasSeenDownload = action.payload;
    },
    setHasSeenBookmark: (state, action: PayloadAction<boolean>) => {
      state.hasSeenBookmark = action.payload;
    },
    setHasSeenTableOfContents: (state, action: PayloadAction<boolean>) => {
      state.hasSeenTableOfContents = action.payload;
    },
    setHasSeenFollowUp: (state, action: PayloadAction<boolean>) => {
      state.hasSeenFollowUp = action.payload;
    },
    setHasSeenGradeManager: (state, action: PayloadAction<boolean>) => {
      state.hasSeenFollowUp = action.payload;
    },
    setHasSeenManual: (state, action: PayloadAction<boolean>) => {
      state.hasSeenManual = action.payload;
    },
    setHasSeenPresentation: (state, action: PayloadAction<boolean>) => {
      state.hasSeenPresentation = action.payload;
    },
  },
});

export const {
  setHasSeenDifferentiation,
  setHasSeemAssignments,
  setHasSeenGroup,
  setHasSeenDownload,
  setHasSeenBookmark,
  setHasSeenTableOfContents,
  setHasSeenFollowUp,
  setHasSeenGradeManager,
  setHasSeenManual,
  setHasSeenPresentation,
} = ctasSlice.actions;

export const { reducer: ctasSliceReducer } = ctasSlice;
